import { useEffect, useRef } from 'react';
export var useIsMounted = function () {
    var isMounted = useRef(true);
    useEffect(function () { return function () {
        isMounted.current = false;
    }; }, []);
    return isMounted;
};
